import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './TextAndImagesList.css';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import Modal from './Modals/Modal';
import BannerImageModal from './Modals/BannerImageModal';

function BannerImageList({ curriculum, setCurriculum, clCardItem, setClCardItem, lessonParent, isUploadingViaApi, setIsUploadingViaApi }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div className="CITLST NotYetAvailable" onClick={() => setIsOpen(true)}>
        <div className="CITLST_A1">
          <FontAwesomeIcon icon={faImage} />
        </div>
        <div className="CITLST_A2">
          Banner Image
        </div>
      </div>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
        <BannerImageModal curriculum={curriculum} setCurriculum={setCurriculum} clCardItem={clCardItem} setClCardItem={setClCardItem} lessonParent={lessonParent} isUploadingViaApi={isUploadingViaApi} setIsUploadingViaApi={setIsUploadingViaApi} />
      </Modal>
    </div>
  );
}

export default BannerImageList;
